import { z } from 'zod';

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { en, ja } from 'zod/locales';

const zodLocaleMap: Record<
  string,
  () => {
    localeError: z.core.$ZodErrorMap;
  }
> = {
  en: en,
  ja: ja,
  // map actual i18n language tags here
};
export function useSyncZodWithI18n() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const lang = i18n.language;
    const nextMap = zodLocaleMap[lang] ?? zodLocaleMap.ja;
    z.config(nextMap());
  }, [i18n.language]);
}
